import { toast, Bounce, ToastOptions } from "react-toastify";
import { t } from "i18next";

export type ServerError = {
  message: string;
  details?: {
    key_value?: string;
  };
};
export class ToastUtilities {
  static presentSavingToast(promise: Promise<any> | undefined, texts?: { pending?: string; error?: string; success?: string }) {
    if (!promise) return Promise.resolve();

    return new Promise((resolve) =>
      toast.promise(
        promise.then((val) => resolve(val)),
        {
          pending: texts?.pending ?? t("main.saving"),
          error: texts?.error ?? t("main.couldntSave"),
          success: texts?.success ?? t("main.saved"),
        },
        { position: "bottom-right", transition: Bounce, autoClose: 1500 }
      )
    );
  }
  static presentDeletingToast(promise: Promise<any>): Promise<any> {
    return toast.promise(
      promise,
      {
        pending: t("main.deleting"),
        error: t("main.errorOccured"),
        success: t("main.deleted"),
      },
      { position: "bottom-right", transition: Bounce }
    );
  }
  static presentPromise(pending: string, promise: Promise<any>, successText?: string, errorText?: string) {
    return toast.promise(
      promise,
      {
        pending: pending,
        error: errorText ?? t("main.errorOccured"),
        success: successText ?? t("main.success"),
      },
      { position: "bottom-right", transition: Bounce }
    );
  }
  static presentSuccess(text: string, options?: ToastOptions) {
    toast.success(text, { autoClose: 2000, position: "bottom-right", transition: Bounce, ...options });
  }

  static presentServerError(error: ServerError) {
    this.presentError(error.details?.key_value ? t(`error.${error.details.key_value}`) : error.message);
  }

  static presentError(text: string) {
    console.log("Error from toast present: ", text);
    toast.error(text, { autoClose: 8000, position: "bottom-right", transition: Bounce });
  }

  static presentWarning(text: string) {
    toast.warning(text, { autoClose: 4000, position: "bottom-right", transition: Bounce });
  }

  static presentInfo(text: string) {
    toast.info(text, { autoClose: 4000, position: "bottom-right", transition: Bounce });
  }
}
